import { of } from "rxjs";
import { tradingConfig } from "../../../utils/config";
export var CreateOrderPrepare = function CreateOrderPrepare(request, botType, base) {
  // 参加杠杆代币考试
  var needEnterLCE = tradingConfig.accountManager.needEnterLCE(base);
  if (needEnterLCE) {
    return of(false);
  }
  // 绑定谷歌二次验证
  var needShowGA = tradingConfig.gaBindGuideShow.showIfNeed();
  return of(!needShowGA);
};